import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaRobot, FaServer, FaChartLine, FaTools } from 'react-icons/fa';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      icon: <FaCheckCircle />,
      title: 'Manual Testing',
      color: '#10b981',
      skills: [
        'SDLC & STLC',
        'Test Planning & Strategy',
        'Test Case Design Techniques',
        'Smoke, Sanity, Regression, UAT',
        'Defect Life Cycle',
        'Cross-browser & Responsive Testing'
      ]
    },
    {
      icon: <FaRobot />,
      title: 'Automation Testing',
      color: '#3b82f6',
      skills: [
        'Selenium',
        'PyTest',
        'Page Object Model (POM)',
        'Data-driven frameworks',
        'CI/CD integration'
      ]
    },
    {
      icon: <FaServer />,
      title: 'API Testing',
      color: '#8b5cf6',
      skills: [
        'Postman',
        'REST APIs',
        'Status Codes & JSON validation',
        'Authentication (JWT, Bearer Token)'
      ]
    },
    {
      icon: <FaChartLine />,
      title: 'Performance Testing',
      color: '#f59e0b',
      skills: [
        'JMeter',
        'Load, Stress, Spike testing',
        'Response time & throughput analysis'
      ]
    },
    {
      icon: <FaTools />,
      title: 'Tools',
      color: '#ef4444',
      skills: [
        'Jira',
        'Git & GitHub',
        'SQL (basic queries)',
        'Browser DevTools'
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Skills & Tools</h2>
          <p className="section-subtitle">
            Comprehensive QA expertise across manual, automation, API, and performance testing
          </p>
        </motion.div>

        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <motion.div
              key={index}
              className="skill-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
            >
              <div className="skill-header" style={{ backgroundColor: `${category.color}15` }}>
                <div className="skill-icon" style={{ color: category.color }}>
                  {category.icon}
                </div>
                <h3 style={{ color: category.color }}>{category.title}</h3>
              </div>
              <ul className="skill-list">
                {category.skills.map((skill, idx) => (
                  <motion.li
                    key={idx}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 + idx * 0.05 }}
                  >
                    <span className="skill-bullet" style={{ backgroundColor: category.color }}></span>
                    {skill}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="skills-summary"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
        >
          <div className="summary-card">
            <h4>Testing Methodologies</h4>
            <p>Agile, Waterfall, V-Model, Test-Driven Development (TDD)</p>
          </div>
          <div className="summary-card">
            <h4>Documentation</h4>
            <p>Test Plans, Test Cases, Bug Reports, RTM, Test Summary Reports</p>
          </div>
          <div className="summary-card">
            <h4>Collaboration</h4>
            <p>Cross-functional team collaboration, stakeholder communication</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
